// extracted by mini-css-extract-plugin
export default {"game-frame":"woe_game-frame__bQe+B"};